import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import { IGetPageBuilder } from "../search/interfaces/api-seach-interfaces";
import {
  IGetAddress,
  IGetApplicationParams,
  IGetCheckoutBuilder,
  IGetContactUsBuilder,
  IGetFields,
  IGetFromURL,
  IGetFromURLParams,
  IGetProfile,
} from "./interfaces/interfaces";
const subBaseURL = "/builder";
const URLs = {
  addressItem: subBaseURL + "/address/item",
  student: subBaseURL + "/students/item",
  form: subBaseURL + "/agents/item",
  application: subBaseURL + "/applications/item",
  addressPageBuilder: subBaseURL + "/address",
  registration: subBaseURL + "/registration",
  cartPageBuilder: subBaseURL + "/cart",
  checkoutPageBuilder: subBaseURL + "/checkout",
  profilePageBuilder: subBaseURL + "/profile",
  contactUsPageBuilder: subBaseURL + "/contact-us",
};
class ApiBuilder extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getAddress = (id?: number): Promise<IGetAddress> => {
    let url = URLs.addressItem;
    if (id) url += "/" + id;
    return this.get(url, {});
  };
  getStudentBuilder = (id?: number): Promise<IGetAddress> => {
    let url = URLs.student;
    if (id) url += "/" + id;
    return this.get(url, {});
  };
  getAgentFormBuilder = (id?: number): Promise<IGetAddress> => {
    let url = URLs.form;
    if (id) url += "/" + id;
    return this.get(url, {});
  };
  getApplication = (params: IGetApplicationParams): Promise<IGetAddress> => {
    // let url = URLs.application;
    // if (id) url += "/" + id;
    return this.get(URLs.application, { params });
  };
  getRegisterFields = (invoice_id?: number): Promise<IGetFields> => {
    const url = invoice_id
      ? URLs.registration + "?reference_id=" + invoice_id
      : URLs.registration;
    return this.get(url, {});
  };
  getFromURL = (params: IGetFromURLParams): Promise<IGetFromURL> =>
    this.get(params.url + "?" + params.parentName + "=" + params.parentKey);
  getAddressPageBuilder = (): Promise<IGetPageBuilder> => {
    return this.get(URLs.addressPageBuilder, {});
  };
  getCartPageBuilder = (): Promise<IGetPageBuilder> => {
    return this.get(URLs.cartPageBuilder, {});
  };
  getCheckoutPageBuilder = (): Promise<IGetCheckoutBuilder> => {
    return this.get(URLs.checkoutPageBuilder, {});
  };
  getProfilePageBuilder = (): Promise<IGetProfile> => {
    return this.get(URLs.profilePageBuilder, {});
  };
  getContactUsPageBuilder = (): Promise<IGetContactUsBuilder> => {
    return this.get(URLs.contactUsPageBuilder, {});
  };
}

export default ApiBuilder;
